import PropTypes from 'prop-types';
import React from 'react';
import {includes} from 'lodash';
import {EARNING_STATUSES} from 'shared/utils';
import NormalText from './normal-text';

const propTypes = {
  status: PropTypes.string.isRequired,
  earnings: PropTypes.number,
  earningsDivisor: PropTypes.number.isRequired,
  difference: PropTypes.number,
  previousEarnings: PropTypes.number,
  showNewEarnings: PropTypes.bool,
  animated: PropTypes.bool,
  showPerYearEarnings: PropTypes.bool,
  maxStudentEarningsReached: PropTypes.bool,
};

const EarningText = ({
  animated,
  earnings,
  earningsDivisor,
  showNewEarnings,
  previousEarnings,
  difference,
  status,
  showPerYearEarnings,
  maxStudentEarningsReached,
}) => {
  if (includes(EARNING_STATUSES, status)) {
    return (
      <NormalText
        difference={difference}
        animated={animated}
        showNewEarnings={showNewEarnings}
        earnings={earnings}
        earningsDivisor={earningsDivisor}
        previousEarnings={previousEarnings}
        showPerYearEarnings={showPerYearEarnings}
        submitted={status === 'submitted'}
        maxStudentEarningsReached={maxStudentEarningsReached}
      />
    );
  }
  return null;
};

EarningText.propTypes = propTypes;

export default EarningText;
